import type {
  IShopifyPageAssigned,
  IShopifyPageAssignedResponse,
  ShopifyAsset,
} from '~/modules/shopify';
import { extractAssetKeys } from '~/utils';

export const processAssetUnassigned = (
  templateAssigned: IShopifyPageAssignedResponse,
  processedAssets: ShopifyAsset[],
) => {
  const assetKeys = new Set(processedAssets.map(extractAssetKeys));
  const unassignedInfo = Object.entries(templateAssigned).reduce(
    (acc, [key, { total, url, data }]) => {
      if (assetKeys.has(key)) return acc;
      return {
        total: acc.total + (total || 0),
        url: acc.url || url || '',
        data: (acc.data || []).concat(data || []),
      };
    },
    { total: 0, url: '', data: [] } as IShopifyPageAssigned,
  );

  return unassignedInfo;
};
